(function () {
  'use strict';

  // Show more has to reveal the cards the mobile row cap hides. One click
  // listener, no polling. The countdown and the rest of the page are untouched.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var button = target.closest('.jm-show-more-button');
    if (!button) return;
    var widget = button.closest('.jdgm-reviews-grid-widget');
    if (widget) widget.classList.add('bello-grid-expanded');
  }, true);
})();
